module.exports = __webpack_public_path__ + "media/dietmar_home.bc7bb0c6.wav";